
export function AcroErrorBanner({ message }: { message?: string }) {
  return (
    <div className="h-full flex flex-col items-center justify-center gap-2 text-center text-sm text-red-500">
      Unable to load the template preview.
      {message && <span className="text-xs text-gray-400">{message}</span>}
    </div>
  );
}

export default AcroErrorBanner;
